import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.NewRequestPopup.EmptyContent', {
    title: 'Looks like you are not added as {br}a requester to any approval workflow',
});
